import React, { Component } from "react";
import Aux from "../../../hoc/Auxilliary";
import Spinner from "../../User/Common/Spinner/Spinner";
import {
  setAdminToken,
  setAdminLang,
  setBrightcoveAccountId,
  setTotalQuestions,
  setPassPercent,
  setRole,
  setName,
} from "../../../localstorage-service";
import { getAdminToken, getConstants } from "../../../data-service-admin";
import { validateEmail, emptyCheck } from "../../../utilities";
import { ToastContainer } from "react-toastr";

class AdminLogin extends Component {
  state = {
    error: false,
    errorMessage: "",
    email: "",
    password: "",
    showSpinner: false,
    successMessage: "",
  };
  validate(email, password) {
    if (emptyCheck(email)) {
      this.setState({ error: true, errorMessage: "Please enter your email" });
      this.focusElement("inputEmail");
      return false;
    } else if (emptyCheck(password)) {
      this.setState({ error: true, errorMessage: "Please enter password" });
      this.focusElement("inputPassword");
      return false;
    } else if (!validateEmail(email)) {
      this.setState({
        error: true,
        errorMessage: "Please enter a valid email address",
      });
      this.focusElement("inputEmail");
      return false;
    } else {
      this.setState({ error: false, errorMessage: "" });
      return true;
    }
  }
  focusElement(name) {
    this.refs[name].focus();
  }
  getConstantsFromService() {
    getConstants().then((response) => {
      setBrightcoveAccountId(response.data[0].Value);
      setTotalQuestions(response.data[2].Value);
      setPassPercent(response.data[3].Value);
    });
  }

  signInClicked() {
    // container.success(`hi! Now is ${new Date()}`, `///title\\\\\\`);
    // this.refs["toastr1"].success(`hi! Now is ${new Date()}`, `///title\\\\\\`, {
    //   closeButton: true
    // });
    localStorage.setItem("admintoken", "dummytoken");
    const email = this.refs["inputEmail"].value;
    const password = this.refs["inputPassword"].value;
    // setAdminToken("dummytoken");
    // this.props.history.push("/admin/");
    if (this.validate(email, password)) {
      this.setState({ showSpinner: true, error: false });
      const pwdEncoded = encodeURIComponent(password);
      getAdminToken(email, pwdEncoded)
        .then((response) => {
          // console.log(response.data);
          this.setState({ showSpinner: false });
          setAdminToken(response.data.access_token);
          setAdminLang(response.data.language);
          setRole(response.data.roles);
          setName(response.data.name);
          this.getConstantsFromService();
          this.props.history.push("/admin/modules/");
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            showSpinner: false,
            error: true,
            errorMessage: error.response.data.error_description,
          });
          console.log(error);
        });
    }
  }
  render() {
    let errorPlaceholder = null;
    if (this.state.error) {
      errorPlaceholder = <p className="alert alert-danger text-center">{this.state.errorMessage}</p>;
    }

    if (!this.state.error && this.state.successMessage) {
      errorPlaceholder = <p className="alert alert-success text-center">{this.state.successMessage}</p>;
    }
    return (
      <Aux key="aux1">
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <div className="login_bg">
          <div className="container">
            <div className="row">
              <div className="login_text">
                <img src="/images/logo.png" width="152" height="47" alt="logo" />
                <h3>Welcome to the</h3>
                <h3>
                  <span>Flexible Video Manager Authoring Application</span>
                </h3>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="card card-container" id="loginbox">
              <Spinner showSpinner={this.state.showSpinner} />
              {errorPlaceholder}
              <form className="form-signin">
                <input
                  type="email"
                  ref="inputEmail"
                  // onChange={this.handleEmailChange.bind(this)}
                  // value={this.state.email}
                  className="form-control"
                  placeholder="Email address"
                />
                <input
                  type="password"
                  ref="inputPassword"
                  // onChange={this.handlePasswordChange.bind(this)}
                  // value={this.state.password}
                  className="form-control"
                  placeholder="Password"
                />
                <a onClick={() => this.signInClicked()} className="btn btn-lg btn-primary btn-block btn-signin pt-8">
                  Sign in
                </a>
              </form>
            </div>
          </div>
        </div>
        <div id="bg">{/* <img src="/images/login_bg.jpg" alt="" style={{ opacity: 0.6 }} /> */}</div>
      </Aux>
    );
  }
}

export default AdminLogin;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminLogin/AdminLogin.js